import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ScrollTop} from 'primeng/scrolltop';
import {ComponentLoading} from './components/loading/component-loading.component';
import {Message} from 'primeng/message';
import {MessageService} from '../services/message.service';
import {ComponentBreadcrumb} from './components/breadcrumb/component-breadcrumb.component';
import {BreadcrumbService} from '../services/breadcrumb.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ScrollTop, ComponentLoading, Message, ComponentBreadcrumb],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {

  breadcrumbService: BreadcrumbService = inject(BreadcrumbService);
  notificationService: MessageService = inject(MessageService);
  translate: TranslateService = inject(TranslateService);

  constructor() {
    this.translate.addLangs(['en', 'it']);
    this.translate.setDefaultLang('it');
    this.translate.use('it');
  }

}
